import React from 'react'

function Setting() {
  return (
    <div>
      
    </div>
  )
}

export default Setting
